import { render, staticRenderFns } from "./ContentTeaser.vue?vue&type=template&id=2a4722d7&scoped=true&"
import script from "./ContentTeaser.vue?vue&type=script&lang=js&"
export * from "./ContentTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ContentTeaser.vue?vue&type=style&index=0&id=2a4722d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4722d7",
  null
  
)

export default component.exports